module.exports = __webpack_public_path__ + "static/img/TV.d84e018c.svg";